import React, { Component } from 'react';
import { Row } from 'shards-react';
import moment from 'moment';
import { EarthText } from '../../../components';
import { markets } from '../../../controllers/requests';
import './styles.scss';

export class EarthMarketHistory extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, history: [] };
  }

  componentDidMount() {
    const { market } = this.props;
    if (!market) this.pullHistory()
    else this.pullHistoryByMarket();
  }

  componentDidUpdate({ market: prevMarket }) {
    const { market } = this.props;
    if (market !== prevMarket) {
      if (!market) this.pullHistory()
      else this.pullHistoryByMarket();
    }
  }

  pullHistory = () => {
    this.setState({ loading: true });
    markets.getHistory()
      .then(history => this.setState({ history: history || [], loading: false }));
  }

  pullHistoryByMarket = () => {
    const { market } = this.props;
    this.setState({ loading: true });
    markets.getHistoryByMarket(market)
      .then(history => this.setState({ history: history || [], loading: false }));
  }

  render() {
    const { history } = this.state;
    return (
      <div className="text-container">
        <ul className='token-list scrollbar'>
          <li className='token-element-no-avatar'>
            <Row style={{ alignItems: 'center', flexWrap: 'no-wrap' }}>
              <div className='col'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Date
              </EarthText>
              </div>
              <div className='col'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Token
                </EarthText>
              </div>
              <div className='col'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Type
              </EarthText>
              </div>
              <div className='col'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Amount
              </EarthText>
              </div>
              <div className='col'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Price
              </EarthText>
              </div>
              <div className='col not-in-mobile'>
                <EarthText size='xxsmall' fontStyle='bold'>
                  Status
              </EarthText>
              </div>
            </Row>
          </li>
          {
            history.map(
              ({ timestamp, status, type, equityToken, price, amount, id }) => (
                <li className='token-element-no-avatar' onClick={() => this.props.navigate(id)}>
                  <Row style={{ alignItems: 'center', flexWrap: 'no-wrap' }}>
                    <div className='col'>
                      <EarthText size='xxsmall'>
                        {moment(timestamp).calendar()}
                      </EarthText>
                    </div>
                    <div className='col'>
                      <EarthText size='xxsmall'>
                        {equityToken}
                      </EarthText>
                    </div>
                    <div className='col'>
                      <EarthText size='xxsmall'>
                        {type}
                      </EarthText>
                    </div>
                    <div className='col'>
                      <EarthText size='xxsmall'>
                        {amount}
                      </EarthText>
                    </div>
                    <div className='col'>
                      <EarthText size='xxsmall'>
                        {price}
                      </EarthText>
                    </div>
                    <div className='col not-in-mobile'>
                      <EarthText size='xxsmall'>
                        {status}
                      </EarthText>
                    </div>
                  </Row>
                </li>
              )
            )
          }
        </ul>
      </div>
    );
  }
}